import { ContactForm } from '../components/contact/ContactForm'
import { siteConfig } from '../config/site'
import { storeHours } from '../data'

const description = 'Contact Pack Print Mail in Waxahachie for help with shipping, packing, printing, mailbox, notary, and document services.'

export function ContactPage() {
  return (
    <article className="content-page contact-page">
      <title>Contact Us | Pack Print Mail</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${siteConfig.siteUrl}/contact-us`} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteConfig.displayName} />
      <meta property="og:title" content="Contact Us | Pack Print Mail" />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${siteConfig.siteUrl}/contact-us`} />

      <header className="legacy-page-title">
        <div className="inner-shell">
          <p>We are here to help</p>
          <h1>Contact Us</h1>
        </div>
      </header>

      <div className="inner-shell content-page__body contact-page__body">
        <p className="lead">Send us a message, call, or visit Pack Print Mail in Waxahachie for service information and availability.</p>

        <div className="contact-page__grid">
          <ContactForm />

          <aside className="contact-page__sidebar" aria-label="Pack Print Mail contact information">
            <section>
              <h2>Pack Print Mail</h2>
              <address>{siteConfig.address.formatted}</address>
              <a href={siteConfig.phoneHref}>{siteConfig.phone}</a>
              <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a>
            </section>

            <section id="store-hours">
              <h2>Store Hours</h2>
              <dl className="hours-list">
                {storeHours.map((entry) => (
                  <div key={entry.label}>
                    <dt>{entry.label}</dt>
                    <dd>{entry.display}</dd>
                  </div>
                ))}
              </dl>
            </section>
          </aside>
        </div>
      </div>
    </article>
  )
}
